// extracted by mini-css-extract-plugin
export default {"root":"CommissioningInfo_root__YK1JG","container":"CommissioningInfo_container__6tD9y","header":"CommissioningInfo_header__xo9lu","body":"CommissioningInfo_body__KLMQm"};